export const tourTypeError = {
    requiredName: "Vui lòng nhập tên loại tour",
}